import { capitalize, unstable_composeClasses as composeClasses } from "@mui/material";
import { getActionHeaderUtilityClass } from "../classes.js";
function useUtilityClasses(ownerState) {
  const {
    size,
    padded,
    classes,
    expanded,
    hideIcon,
    titleClickable,
    primaryActionVisibility: primaryVis,
    secondaryActionVisibility: secondaryVis
  } = ownerState;
  const slots = {
    root: [
      "root",
      expanded && "expanded",
      size && `size${capitalize(size)}`,
      (expanded || padded) && "padded",
      hideIcon && "hideIcon"
    ],
    chevron: ["chevron"],
    title: ["title", size && `titleSize${capitalize(size)}`, titleClickable && `titleClickable`],
    subtitle: ["subtitle", size && `subtitleSize${capitalize(size)}`],
    primaryAction: ["primaryAction", primaryVis === "hover" && "primaryActionHover"],
    secondaryAction: ["secondaryAction", secondaryVis === "hover" && "secondaryActionHover"]
  };
  return composeClasses(slots, getActionHeaderUtilityClass, classes);
}
export {
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
